import { safeRound } from '@utils/safeRound'

import { ContentProps } from './Content.interface'

const representativeAprContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    const representativeAPR = creditCard.offerDetail.representativeAPR

    if (
        creditCard.guaranteedRate?.guaranteedAPR != null ||
        representativeAPR == null ||
        representativeAPR <= 0
    ) {
        return null
    }

    return {
        title: `Representative % APR (${
            creditCard.isFixedRate ? 'fixed' : 'variable'
        })`,
        value: `${safeRound(representativeAPR, 1)}% APR`,
        detailType: undefined,
    }
}

export default representativeAprContent
